(() => {
  function addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function calculateDeliveryDates(today, countryCode) {
    const dispatch = addCalendarDays(today, 1);
    const india = countryCode === 'IN';
    return {
      dispatch,
      deliveryStart: india ? addCalendarDays(dispatch, 4) : addCalendarDays(today, 10),
      deliveryEnd: india ? addCalendarDays(dispatch, 4) : addCalendarDays(today, 12)
    };
  }

  function monthDay(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function dateRange(start, end) {
    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return `${start.toLocaleDateString('en-US', { month: 'short' })} ${start.getDate()}–${end.getDate()}`;
    }
    return `${monthDay(start)}–${monthDay(end)}`;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { addCalendarDays, calculateDeliveryDates, monthDay, dateRange };
  }
  if (typeof customElements === 'undefined' || customElements.get('kt-product-delivery')) return;

  class KTProductDelivery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const data = this.querySelector('[data-kt-delivery-variants]');
      if (!data) return;
      this.variants = JSON.parse(data.textContent);
      this.updateVariant(this.dataset.initialVariant);
      this.renderDates();

      document.addEventListener('variant:changed', (event) => {
        const id = event.detail?.variant?.id;
        if (id && this.variants.some(variant => String(variant.id) === String(id))) {
          this.updateVariant(id);
        }
      }, { signal });

      this.querySelector('.kt-delivery-search')?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') event.preventDefault();
      }, { signal });

      this.querySelector('.kt-delivery-search')?.addEventListener('input', (event) => {
        const query = event.target.value.trim().toLowerCase();
        let count = 0;
        this.querySelectorAll('[data-kt-delivery-country]').forEach(option => {
          const matches = (option.dataset.search || '').includes(query);
          option.hidden = !matches;
          if (matches) count += 1;
        });
        this.querySelector('.kt-delivery-no-results').hidden = count > 0;
      }, { signal });

      this.querySelector('.kt-delivery-country-form')?.addEventListener('submit', (event) => {
        if (!event.submitter?.matches('[data-kt-delivery-country]')) {
          event.preventDefault();
          return;
        }
        const returnTo = event.currentTarget.querySelector('[name="return_to"]');
        if (returnTo) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('country');
          returnTo.value = currentUrl.pathname + currentUrl.search + currentUrl.hash;
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateVariant(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.querySelector('[data-kt-delivery-ready]').hidden = !variant.ready;
      this.querySelector('[data-kt-delivery-orderable]').hidden = !variant.available || variant.ready;
      this.querySelector('[data-kt-delivery-unavailable]').hidden = variant.available;
    }

    renderDates() {
      const dates = calculateDeliveryDates(new Date(), this.dataset.country);
      this.querySelector('[data-kt-delivery-dispatch]').textContent = monthDay(dates.dispatch);
      this.querySelector('[data-kt-delivery-arrival]').textContent = this.dataset.country === 'IN'
        ? monthDay(dates.deliveryStart)
        : dateRange(dates.deliveryStart, dates.deliveryEnd);
    }
  }

  customElements.define('kt-product-delivery', KTProductDelivery);
})();
